import { render, staticRenderFns } from "./ManageNewArticles.vue?vue&type=template&id=4244d0a4&"
import script from "./ManageNewArticles.vue?vue&type=script&lang=js&"
export * from "./ManageNewArticles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports